module.exports = __webpack_public_path__ + "static/c2-dbf58e49d5349d7b3b4323096c3fb7b3.jpg";